<template>
    <div>
        <br />
        <b-alert variant="primary" show>{{text}}</b-alert>
        <viewFile v-if="uid_file" :uid_element="uid_file"></viewFile>
    </div>
</template>

<script>
    
    import * as json2csv from "json2csv";

    import viewFile from "./viewFile.vue";

    export default {
        name: "signature",
		components: {
            viewFile,
		},
		props: {
			options: {
				default: null
            },
        },
		data() {
			return {
                text: "Un mail vous a été envoyé pour signer ce document.",
                uid_file: null
			};
        },
        methods: {
        },
        async created()
        {
            if (this.options.startsWith("{"))
            {
                var options = JSON.parse(this.options);
                this.uid_file = options.file || null;
                if (options.text)
                    this.text = options.text;
            }
            else
            {
                this.uid_file = this.options;
            }
        }
    }
</script>
